// ----------------------------------------------------------------------------
// Template: Gift Card
// ----------------------------------------------------------------------------
// A file that contains scripts highly couple code to the Gift Card template.
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'sections/header/header';
import 'sections/footer/footer';
import './_gift_card.scss';
import 'snippets/gift-card-recipient-form/gift-card-recipient-form';


// -------------------------------------
// Variables
// -------------------------------------
const config = {
    qrCode: '#QrCode',
    printButton: '#PrintGiftCard',
    giftCardCode: '.giftcard__code',
};


// -------------------------------------
// Helper Functions
// -------------------------------------
function selectText(evt) {
    const text = document.getElementById(evt.data.element);
    let range = '';

    if (document.body.createTextRange) {
        range = document.body.createTextRange();
        range.moveToElementText(text);
        range.select();
    } else if (window.getSelection) {
        const selection = window.getSelection();
        range = document.createRange();
        range.selectNodeContents(text);
        selection.removeAllRanges();
        selection.addRange(range);
    }
}

// -------------------------------------
// Hooks
// -------------------------------------
document.addEventListener('DOMContentLoaded', () => {
    const printButton = document.querySelector(config.printButton);

    printButton?.addEventListener('click', () => {
        window.print();
    });

    // Auto-select gift card code on click, based on ID passed to the function
    document.querySelectorAll(config.giftCardCode).forEach(element => {
        element.addEventListener('click', () => {
            selectText({ data: { element: 'GiftCardDigits' } });
        });
    });
});
